<template>
    <IntegrationSettingsCard icon="fas fa-cogs" :title="__('general.settings')">
        <template v-slot:body>
            <FormGroupNew label="Kundennummer"
                          description="Registrieren Sie sich bei Garantiert Geliefert oder falls Sie bereits ein Konto besitzen, kontaktieren Sie den youbuyda-Support um Ihre Kundennummer eintragen zu lassen."
                          :error="config.errors.gg_customer_id"
                          required
            >
                <input type="text"
                       class="form-control form-control-solid mb-3"
                       :value="config.gg_customer_id"
                       placeholder="Wird automatisch ausgefüllt"
                       readonly
                       disabled
                >
                <Link v-if="!config.gg_customer_id"
                      as="button"
                      class="btn btn-gg"
                      :href="$route('GG.register')"
                      :disabled="!formData.gg_register_url"
                >
                    <i class="fas fa-user-plus"/>
                    Bei Garantiert Geliefert registrieren
                </Link>
            </FormGroupNew>
        </template>

        <template v-slot:footer>
            <div class="border border-danger rounded p-5">
                <div class="font-weight-bold font-size-lg text-danger mb-3">
                    Folgende Einstellungen sind für die Entwicklung gedacht und werden nach Abschluss entfernt.
                </div>
                <FormGroupNew label="Kundennummer"
                              description="Geben Sie die Kundennummer Ihres Garantiert Geliefert Kontos an."
                              :error="config.errors.gg_customer_id"
                              :required="requiredFields.includes('gg_customer_id')"
                >
                    <input type="text" class="form-control" v-model="config.gg_customer_id">
                </FormGroupNew>

                <FormGroupNew label="Registrierungs URL"
                              description="Geben Sie die URL zum Registrierungsformular an."
                              :error="config.errors.gg_register_url"
                              :required="requiredFields.includes('gg_register_url')"
                >
                    <input type="text" class="form-control" v-model="config.gg_register_url">
                </FormGroupNew>

                <FormGroupNew label="Fahrtenauswahl URL"
                              description="Geben Sie die URL zur Auswahl einer Fahrt an."
                              :error="config.errors.gg_select_driver_url"
                              :required="requiredFields.includes('gg_select_driver_url')"
                >
                    <input type="text" class="form-control" v-model="config.gg_select_driver_url">
                </FormGroupNew>

                <SaveAndEnableButton :disabled="!config.isDirty" @click="saveUserSettings"/>

                <DividerDotted/>

                <Link as="button"
                      :href="$route('GG.orders.fake')"
                      class="btn btn-light-warning">
                    <i class="fas fa-plus-square"/>
                    Testbestellung erstellen
                </Link>
            </div>
        </template>
    </IntegrationSettingsCard>
</template>

<script>
import IntegrationSettingsCard from "@components/Integrations/IntegrationSettingsCard.vue";
import IntegrationsSettingsLayout from "@layouts/IntegrationsSettingsLayout.vue";
import FormGroupNew from "@components/Form/FormGroupNew.vue";
import integrationUserConfigMixin from "@mixins/integrationUserConfigMixin";
import SaveAndEnableButton from "@components/Integrations/SaveAndEnableButton.vue";
import DividerDotted from "@components/Form/DividerDotted.vue";
import { Link } from '@inertiajs/vue2';

export default {
    components: {DividerDotted, SaveAndEnableButton, FormGroupNew, IntegrationSettingsCard, Link},

    layout: IntegrationsSettingsLayout,

    mixins: [integrationUserConfigMixin]
}
</script>
